import { render, staticRenderFns } from "./appId.vue?vue&type=template&id=283560b3&"
import script from "./appId.vue?vue&type=script&lang=js&"
export * from "./appId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports